import React from "react";
import { useTranslation } from "react-i18next";
import EACheckbox from "../../shared/Checkbox/EACheckbox";
import { Controller } from "react-hook-form";
import CheckBoxNewsletter from "../inputsForm/CheckBoxNewsletter";
import useFacility from "../../../../utils/hooks/useFacility";
import "./ConsentInputs.scss";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import OtherConsentCheckboxes from "./OtherConsentCheckboxes";
import EALink from "../../shared/Link/EALink";

interface IProps {
  errors: any;
  control: any;
  setValue: any;
  email?: string;
  title?: string;
}

const ConsentInputs: React.FC<IProps> = ({ errors, control, setValue, email = "", title = "" }) => {
  const configuration = useSelector((state: State) => state.config.configuration);
  const { t } = useTranslation();
  const facilityIds = useFacility();
  const regulaminList = useSelector((state: State) => state.config.configuration?.regulaminList) || [];

  const getStoreTermsText = () => {
    const storeTerms = regulaminList?.find((item) => item?.type === "StoreTerms");
    if (storeTerms?.active && storeTerms?.file) {
      return (
        <>
          {" "}
          {t("oraz")}{" "}
          <a target="_blank" rel="noreferrer" href={storeTerms.file}>
            {t("regulamin")} {t("sprzedaży")}
          </a>
        </>
      );
    }
    return "";
  };

  return (
    <div className="consent-inputs__container">
      {title && <h3>{title}</h3>}

      <Controller
        name="acceptEAktywni"
        control={control}
        rules={{ required: true }}
        render={({ field }) => (
          <EACheckbox
            name="acceptEAktywni"
            field={field}
            errors={errors}
            label={
              <span>
                *{t("akceptuje")} {""}
                <a target="_blank" rel="noreferrer" href={"https://eaktywni.pl/regulamin/"}>
                  {t("regulamin")} {t("serwisu")} eAktywni.pl
                </a>
                {getStoreTermsText()}
              </span>
            }
          />
        )}
      />

      {facilityIds === "1228" || (facilityIds === "1224" && <CheckBoxNewsletter email={email} />)}

      <OtherConsentCheckboxes errors={errors} control={control} setValue={setValue} />

      <span className="body-text-small">
        {t(
          "Dane osobowe zbieramy na potrzeby realizacji i zakupu biletów, więcej o tym jak przetwarzamy dane osobowe dowiesz się tutaj:"
        )}{" "}

{configuration.regulaminList[0] && (
            <EALink to={configuration.regulaminList[0].file} title="Polityka prywatności" />
          )}
      </span>
    </div>
  );
};

export default ConsentInputs;
